import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'
import StandardButton from '../app_components/StandardButton'
import MeetingResponse from './MeetingResponse'

class MeetingButtonSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      responseType: '',
      responseFormOpen: false
    }

    this.toggleResponseForm = this.toggleResponseForm.bind(this)
  }

  toggleResponseForm(type) {
    this.props.getAllMeetings()
    this.setState({
      responseFormOpen: !this.state.responseFormOpen,
      responseType: type
    })
  }

  renderButtons() {
    //detail page view
    if (this.props.meeting.status === 'Cancelled') {
      return null
    //detail page view
    } else {
        if(moment(this.props.meeting.meeting_time).isBefore(moment(Date.today)) && this.props.meeting.accepted != true){
          return null
        //if current user is requestee and it's unaccepted, prompt user to respond to request
        } else if(this.props.meeting.accepted === false && this.props.meeting.requestor_id != this.props.currentUser.id) {
          return(
            <div className="meetingButtonSection" >
              <StandardButton
                primary={true}
                size={"small"}
                text="Respond to Request"
                onClick={() => this.toggleResponseForm('respond')}/>
            </div>
          )
        } else if(this.props.meeting.status != "Cancelled") {
            return(
              <div className="meetingButtonSection" >
                <StandardButton
                  primary={false}
                  size={"small"}
                  text="Change"
                  onClick={() => this.toggleResponseForm('change')}/>
                <div style={{width: 10}}></div>
                <StandardButton
                  primary={true}
                  size={"small"}
                  text="Plan Lex"
                  onClick={() => window.location.assign(`/meetings/${this.props.meeting.id}`)}/>
              </div>
            )
        }
    }
  }



  render() {
    return(
      <div style={{ alignSelf: 'flex-end'}}>
        {this.state.responseFormOpen &&
          <MeetingResponse
            type={this.state.responseType}
            onClose={() => this.toggleResponseForm('')}
            meeting={this.props.meeting}
            getAllMeetings={this.props.getAllMeetings}
          />}
        {this.renderButtons()}
      </div>
    )
  }
}

export default MeetingButtonSection;
